exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".book-menu-list[data-v-bf498ff6] .el-card__body{padding:0}.book-menu-list[data-v-bf498ff6] .el-card__body .el-tree-node__content{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:auto;flex:auto}\n", ""]);

// exports
